/**
 * Home: redirect to role-specific dashboard or login
 */

import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const ROLE_DASHBOARD = {
  STUDENT: '/dashboard/student',
  FACULTY: '/dashboard/faculty',
  ADMIN: '/dashboard/admin',
  SUPER_ADMIN: '/dashboard/super-admin',
  PARENT: '/dashboard/parent',
  ALUMNI: '/dashboard/alumni',
  INDUSTRY_EXPERT: '/dashboard/industry-expert',
};

export default function Home() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="page-loader">
        <div className="page-loader-inner">
          <span className="spinner" aria-hidden="true" />
          <span className="text-sm font-medium" style={{ color: 'var(--text-secondary)' }}>
            Loading…
          </span>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  const path = ROLE_DASHBOARD[user.role] || '/dashboard/student';
  return <Navigate to={path} replace />;
}
